import { cryptoInstance } from '@/public/fetch/index';
import { data } from '@/public/utils/basePath';
let baseURL = data;
/* 浏览共学营、omo 触发销售易消息提醒功能 用户行为统计 */
export const customerAct = (params, data) => {
    return cryptoInstance.post(`/action2/${params.userId}/${params.typeText}`, data, {
        baseURL
    });
};
